module.exports = __webpack_public_path__ + "img/21_37.6cf32bfc.png";